/**
 * @Author: v_jppjpeng
 * @Date: 2024-01-22 10:19:53
 * @Explain: svg - icon
 */
import classNames from 'classnames';
import { useMemo } from 'react';
import { IconProps } from '../data.d';

const fun = (props: IconProps) => {
  const {
    mode,
    className = '',
    style,
    name,
    size,
    fontSize,
    color,
    bold,
    onClick,
  } = props;

  const customStyle = useMemo(() => {
    const config = {
      width: size,
      height: size,
      color,
      ...style,
    };
    if (fontSize) {
      config.fontSize = fontSize;
    }
    if (bold) {
      config.fontWeight = '700';
    }
    return config;
  }, [size, fontSize, color, bold, style]);

  // 图标名
  const iconName = useMemo(() => `icon-${name}`, [name]);

  return mode === 'font' ? (
    <i
      className={classNames(
        {
          iconfont: true,
          [iconName]: name,
        },
        className,
      )}
      style={customStyle}
      onClick={onClick}
    />
  ) : (
    <svg
      className={classNames('svg-icon', className)}
      aria-hidden="true"
      style={customStyle}
      onClick={onClick}
    >
      <use xlinkHref={`#${iconName}`}></use>
    </svg>
  );
};

const Icon = {
  Font: (props: IconProps) =>
    fun({
      ...props,
      mode: 'font',
    }),
  Svg: (props: IconProps) =>
    fun({
      ...props,
      mode: 'svg',
    }),
};

export default Icon;
